import {Rate} from '@dms/api/core';

export const vatRateToOption = (rate: Rate) => ({
  value: rate.type,
  label: `${rate.rate} % ${rate.name}`,
  fieldLabel: `${rate.rate} %`,
});
